// extracted by mini-css-extract-plugin
module.exports = {"LoginForm":"LoginForm--2VBza","Extra":"Extra--21CC0","Flat":"Flat--2GKvZ"};